module.exports = __webpack_public_path__ + "img/briefcase-fill.3c9b62a3.svg";